export const ANSWER_OPTIONS = [
  {
    label: "OK",
    value: "OK",
  },
  {
    label: "No OK",
    value: "No OK",
  },
  {
    label: "N/A",
    value: "N/A",
  },
];
export const BASE_URL = "/home/carros-motor";

export const STATUS = {
  IMPORTED: "IMPORTED",
  IN_PROGRESS: "IN_PROGRESS",
  CLOSED: "CLOSED",
};

export const ADMIN_PROFILES = [
  "GENERAL_ADMIN",
  "MRO_CDM_SUPERVISOR",
  "MRO_SUPERVISOR",
  "MRO_SUPERVISOR_ENGINE",
  "MRO_ADMIN",
];

export const TMA_PROFILES = ["MRO_CDM_TMA", "MRO_TMA", "MRO_TMA_ENGINE"];
